// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/user_preference.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/user_preference.proto.
 */
export const file_v1_user_preference: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message v1.UserPreference
 */
export type UserPreference = Message<"v1.UserPreference"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: int32 data_retention_duration_days = 3;
   */
  dataRetentionDurationDays: number;

  /**
   * @generated from field: bool allow_amount_none_dot_format = 4;
   */
  allowAmountNoneDotFormat: boolean;

  /**
   * @generated from field: bool allow_cross_combo_one_station_syntax = 5;
   */
  allowCrossComboOneStationSyntax: boolean;

  /**
   * @generated from field: bool allow_cross_combo_dot_format = 6;
   */
  allowCrossComboDotFormat: boolean;

  /**
   * @generated from field: bool allow_lotto_4_3_digit_syntax = 7;
   */
  allowLotto43DigitSyntax: boolean;

  /**
   * @generated from field: bool allow_b4s_xc_syntax = 8;
   */
  allowB4sXcSyntax: boolean;

  /**
   * @generated from field: bool allow_xc_dd_syntax = 9;
   */
  allowXcDdSyntax: boolean;

  /**
   * @generated from field: bool allow_exchange_to_cross_combo = 10;
   */
  allowExchangeToCrossCombo: boolean;

  /**
   * @generated from field: string exchange_to_cross_combo_types = 11;
   */
  exchangeToCrossComboTypes: string;

  /**
   * Root font size in CSS pixels. Minimum 16 to stop iOS Safari zooming the
   * page when an input takes focus.
   *
   * @generated from field: int32 font_size_px = 12;
   */
  fontSizePx: number;

  /**
   * CSS font-family stack applied to the whole application. Empty means the
   * application default.
   *
   * @generated from field: string font_family = 13;
   */
  fontFamily: string;
};

/**
 * Describes the message v1.UserPreference.
 * Use `create(UserPreferenceSchema)` to create a new message.
 */
export const UserPreferenceSchema: GenMessage<UserPreference> = /*@__PURE__*/
  messageDesc(file_v1_user_preference, 0);

/**
 * No parameters needed as username comes from JWT context
 *
 * @generated from message v1.GetUserPreferenceRequest
 */
export type GetUserPreferenceRequest = Message<"v1.GetUserPreferenceRequest"> & {
};

/**
 * Describes the message v1.GetUserPreferenceRequest.
 * Use `create(GetUserPreferenceRequestSchema)` to create a new message.
 */
export const GetUserPreferenceRequestSchema: GenMessage<GetUserPreferenceRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_preference, 1);

/**
 * @generated from message v1.GetUserPreferenceResponse
 */
export type GetUserPreferenceResponse = Message<"v1.GetUserPreferenceResponse"> & {
  /**
   * @generated from field: v1.UserPreference user_preference = 1;
   */
  userPreference?: UserPreference;
};

/**
 * Describes the message v1.GetUserPreferenceResponse.
 * Use `create(GetUserPreferenceResponseSchema)` to create a new message.
 */
export const GetUserPreferenceResponseSchema: GenMessage<GetUserPreferenceResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_preference, 2);

/**
 * @generated from message v1.UpsertUserPreferenceRequest
 */
export type UpsertUserPreferenceRequest = Message<"v1.UpsertUserPreferenceRequest"> & {
  /**
   * Min: 1, Max: 60
   *
   * @generated from field: int32 data_retention_duration_days = 1;
   */
  dataRetentionDurationDays: number;

  /**
   * @generated from field: bool allow_amount_none_dot_format = 2;
   */
  allowAmountNoneDotFormat: boolean;

  /**
   * @generated from field: bool allow_cross_combo_one_station_syntax = 3;
   */
  allowCrossComboOneStationSyntax: boolean;

  /**
   * @generated from field: bool allow_cross_combo_dot_format = 4;
   */
  allowCrossComboDotFormat: boolean;

  /**
   * @generated from field: bool allow_lotto_4_3_digit_syntax = 5;
   */
  allowLotto43DigitSyntax: boolean;

  /**
   * @generated from field: bool allow_b4s_xc_syntax = 6;
   */
  allowB4sXcSyntax: boolean;

  /**
   * @generated from field: bool allow_xc_dd_syntax = 7;
   */
  allowXcDdSyntax: boolean;

  /**
   * @generated from field: bool allow_exchange_to_cross_combo = 8;
   */
  allowExchangeToCrossCombo: boolean;

  /**
   * @generated from field: string exchange_to_cross_combo_types = 9;
   */
  exchangeToCrossComboTypes: string;
};

/**
 * Describes the message v1.UpsertUserPreferenceRequest.
 * Use `create(UpsertUserPreferenceRequestSchema)` to create a new message.
 */
export const UpsertUserPreferenceRequestSchema: GenMessage<UpsertUserPreferenceRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_preference, 3);

/**
 * @generated from message v1.UpsertUserPreferenceResponse
 */
export type UpsertUserPreferenceResponse = Message<"v1.UpsertUserPreferenceResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: v1.UserPreference user_preference = 3;
   */
  userPreference?: UserPreference;
};

/**
 * Describes the message v1.UpsertUserPreferenceResponse.
 * Use `create(UpsertUserPreferenceResponseSchema)` to create a new message.
 */
export const UpsertUserPreferenceResponseSchema: GenMessage<UpsertUserPreferenceResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_preference, 4);

/**
 * @generated from message v1.UpsertAppearancePreferenceRequest
 */
export type UpsertAppearancePreferenceRequest = Message<"v1.UpsertAppearancePreferenceRequest"> & {
  /**
   * Min: 16, Max: 25
   *
   * @generated from field: int32 font_size_px = 1;
   */
  fontSizePx: number;

  /**
   * Must be one of the supported font stacks
   *
   * @generated from field: string font_family = 2;
   */
  fontFamily: string;
};

/**
 * Describes the message v1.UpsertAppearancePreferenceRequest.
 * Use `create(UpsertAppearancePreferenceRequestSchema)` to create a new message.
 */
export const UpsertAppearancePreferenceRequestSchema: GenMessage<UpsertAppearancePreferenceRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_preference, 5);

/**
 * @generated from message v1.UpsertAppearancePreferenceResponse
 */
export type UpsertAppearancePreferenceResponse = Message<"v1.UpsertAppearancePreferenceResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: v1.UserPreference user_preference = 3;
   */
  userPreference?: UserPreference;
};

/**
 * Describes the message v1.UpsertAppearancePreferenceResponse.
 * Use `create(UpsertAppearancePreferenceResponseSchema)` to create a new message.
 */
export const UpsertAppearancePreferenceResponseSchema: GenMessage<UpsertAppearancePreferenceResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_preference, 6);

/**
 * @generated from service v1.UserPreferenceService
 */
export const UserPreferenceService: GenService<{
  /**
   * @generated from rpc v1.UserPreferenceService.GetUserPreference
   */
  getUserPreference: {
    methodKind: "unary";
    input: typeof GetUserPreferenceRequestSchema;
    output: typeof GetUserPreferenceResponseSchema;
  },
  /**
   * @generated from rpc v1.UserPreferenceService.UpsertUserPreference
   */
  upsertUserPreference: {
    methodKind: "unary";
    input: typeof UpsertUserPreferenceRequestSchema;
    output: typeof UpsertUserPreferenceResponseSchema;
  },
  /**
   * UpsertAppearancePreference saves only the appearance (font) preference.
   *
   * Kept separate from UpsertUserPreference because that call overwrites every
   * preference column: a partial payload sent from the app bar quick menu would
   * silently reset the parser syntax flags and the data retention period.
   *
   * @generated from rpc v1.UserPreferenceService.UpsertAppearancePreference
   */
  upsertAppearancePreference: {
    methodKind: "unary";
    input: typeof UpsertAppearancePreferenceRequestSchema;
    output: typeof UpsertAppearancePreferenceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_user_preference, 0);

